import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { HeaderComponent } from '../components/header/header.component';
import { SubheaderComponent } from '../components/subheader/subheader.component';

@Component({
  selector: 'app-verification-module',
  standalone: true,
  imports: [
    CommonModule,
    SidebarComponent,
    HeaderComponent,
    SubheaderComponent
  ],
  templateUrl: './verification-module.component.html',
  styleUrl: './verification-module.component.css'
})
export class VerificationModuleComponent implements AfterViewInit, OnDestroy {
  constructor(private router: Router) {}

  @ViewChild('videoEl', { static: false }) videoEl!: ElementRef<HTMLVideoElement>;
  private stream: MediaStream | null = null;
  cameraError: string | null = null;

  async ngAfterViewInit(): Promise<void> {
    await this.startCamera();
  }

  ngOnDestroy(): void {
    this.stopCamera();
  }

  async startCamera(): Promise<void> {
    try {
      this.cameraError = null;
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'user' },
        audio: false
      });
      const video = this.videoEl?.nativeElement;
      if (video) {
        video.srcObject = this.stream;
        await video.play();
      }
    } catch (err: any) {
      this.cameraError = 'No se pudo acceder a la cámara. Verifica permisos.';
      console.error('Error al iniciar cámara:', err);
    }
  }

  stopCamera(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop());
      this.stream = null;
    }
  }

  goBack(): void {
    this.router.navigate(['/verify-identity']);
  }

  onContinue(): void {
    this.router.navigate(['/upload-documents']);
  }
}
